import BaseModel from './base';
import { rServices } from '@/plugins/api';

const upperFirst = (text) => {
  const transformedText = text.toLowerCase();

  return transformedText[0].toUpperCase() + transformedText.slice(1);
};

export default class BaseModelJournal extends BaseModel {
  constructor(journal, url) {
    super(journal, url);

    this.id = journal.id;
    this.score = journal.score;
    this.questions = journal.questions;
    this.is_confirm = journal.is_confirm;
    this.is_checked = journal.is_checked;
    this.poll_id = journal.poll_id;
    this.owner_id = journal.owner_id;
    this.event_stage_id = journal.event_stage_id;
    this.expires = journal.expires;
    this.finished_at = journal.finished_at;
    this.attempt = journal.attempt;
    this.final_at = journal.final_at;
    this.team_id = journal.team_id;
    this.group_id = journal.group_id;

    this.title = (journal.title && upperFirst(journal.title)) || null;
    this.owner = journal?.owner || null;
    this.own_score = journal?.own_score || null;
    this.not_own_expertises_count = journal?.not_own_expertises_count || 0;
    this.has_own_completed_expertise = journal?.has_own_completed_expertise || null;
    this.has_all_answers = journal?.has_all_answers || null;
    this.user_event_info_values = journal?.user_event_info_values || null;
    this.user_directory_documents = journal?.user_directory_documents || null;

    this.avg_expertises_score = journal.avg_expertises_score;
    this.sum = journal.sum;
  }

  /**
   * Истек ли срок действия прохождения
   * @return boolean
   */
  get isExpired() {
    return !this.expires && this.final_at;
  }

  /**
   * Завершено ли выполнение заданий
   * @return boolean
   */
  get isFinished() {
    return this.finished_at;
  }

  get journalTitle() {
    return this.title || `#${this.id}`;
  }

  /**
   * Завершить проходение заданий
   */
  finish(payload) {
    const args = [this.id];

    return rServices.polls.answers.finishPoll({ args, data: payload });
  }
}
